// INSERIMENTO DATA DI CONSEGNA



// FACEBOOK PIXEL EVENTS
if ( $( ".product_form" ).length ) {
  var prodata = JSON.parse($(".product_form").attr('data-product'));      
  
  $('body').on("submit", ".product_form", function(){
    if (typeof fbq == 'function') {
      fbq('track', 'AddToCart', {
        content_ids: prodata.id,
        value: prodata.price/100,
        content_type: 'product',
        currency: 'EUR'
      });
    }
  });
}

$('body').on("submit", "#cart_form, .js-cart_content__form", function(){
  if (typeof fbq == 'function') {
    fbq('track', 'InitiateCheckout');
  }
});

function trackFbVc(id,value,currency) {
  if (typeof fbq == 'function') {
    fbq('track', 'ViewContent', {
      content_ids: id,
      content_type: 'product',
      value: value,
      currency: 'EUR'
    })
  }
}

function trackGuideView() {
  if (typeof ga == 'function') {ga('send', 'event', 'Custom', 'Viewed Guide');}
}

// LINK ALLE TABS
$('body').on('click', '#revietit', function(e) {
  e.preventDefault();
  $('#review_tab:not(.active)').addClass('active');
  $('#review_tab').next().show();
  $('html, body').animate({scrollTop: $('#review_tab').offset().top -65},1000);
});

$('body').on('click', '#productDetails', function(e) {
  e.preventDefault();
  $('#details_tab:not(.active)').addClass('active');
  $('#details_tab').next().show();
  $('html, body').animate({scrollTop: $('#details_tab').offset().top -65},1000);
});

// SHAKE FUNCTION
function Shakes(element) {
  element.addClass('apply-shake');
  element.bind("animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd", function(){
    element.removeClass('apply-shake');
  });
}

// SHAKE SELECTS
$(".add_disabled").click(function (evt) {
  Shakes($('.single-option-selector option[value="select"]:selected').parent('select'));
  console.log('ciao');
});


function close_accordion_section() {
  jQuery('.accordion .accordion-section-title').removeClass('active');
  jQuery('.accordion .accordion-section-content').slideUp(300).removeClass('open');
}

jQuery('.accordion-section-title').click(function(e) {
  // Grab current anchor value
  var currentAttrValue = jQuery(this).attr('href');
  
  if(jQuery(e.target).is('.active')) {
    close_accordion_section();
  }else {
    close_accordion_section();
    
    // Add active class to section title
    jQuery(this).addClass('active');
    // Open up the hidden content panel
    jQuery('.accordion ' + currentAttrValue).slideDown(300).addClass('open'); 
  }
  
  e.preventDefault();
});

$(document).ready(function() {
  if($('body').hasClass('product')){
    $(".fancybox").fancybox();
  }
  
  $('a[data-dropdown-rel="searchx"]').on('click', function(){
    $('div[data-dropdown="search"]').toggleClass('tgsearch');
    $('body').toggleClass('fixedover');
    return false;
  });
  $('span.search-close').on('click', function(){
    $('div[data-dropdown="search"]').removeClass('tgsearch');
    $('body').removeClass('fixedover');
  });
  
  $('.product').on('click','.c_checked ',function(){
    let var_val = $(this).attr('value').trim()
    let color_opt = $('.custom_color .current img').attr('title').trim();
    let comb = var_val + ' / '+ color_opt;
    let var_id;
    let c_flag = $('.u_c_fag').val
    $('.custom-scu_master-select option').each(function(){
      if($(this).text().trim() == comb){
        var_id = $(this).val()
        console.log('matrch',var_id)
        if($(this).attr('data-iq-h') <= 0){
          if(typeof $('.u_c_fag').val() != 'undefined'){
            $('.u_notify_btn').val('JOIN THE WAITLIST')
          }
          else{
            $('.u_notify_btn').val('NOTIFY ME')
          }
        }
      }
    })
    console.log('id',var_id)
    $('.u_not_var_id').attr('value',var_id)
  })
  $('.product').on('click','.u_notify_btn',function(){
    $('.u_notify_wrapper').show()
  })
  $('.product').on('click','.u_notify_overlay,.u_notify_close,.u_notify_sp_close',function(){
    $('.u_notify_email_inp').val('')
    // $('.u_notify_succ').hide()
    $('.u_notify_cbtn_block').show()
    $('.u_notify_wrapper').hide()
  })
  

  $('#klaviyo-form').on('submit', function(e) {
    e.preventDefault();
    
    let notify_email = $(this).find('.u_notify_email_inp').val();
    let product_variant_id = $(this).find('.u_not_var_id').val();
    console.log("notify_email", notify_email);
    console.log("product_variant_id", product_variant_id);

      const settings = {
  async: true,
  crossDomain: true,
  url: 'https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=XBfV5N',
  method: 'POST',
  headers: {
    accept: 'application/vnd.api+json',
    revision: '2024-10-15',
    'content-type': 'application/vnd.api+json'
  },
  data: `{"data":{"type":"back-in-stock-subscription","attributes":{"profile":{"data":{"type":"profile","attributes":{"email":"${notify_email}"}}},"channels":["EMAIL"]},"relationships":{"variant":{"data":{"type":"catalog-variant","id":"$shopify:::$default:::${product_variant_id}"}}}}}`
};

$.ajax(settings)
  .done(res => {
    console.log("Response:", res);
    $(".u_notify_succ").text("Submit successfully");
    setTimeout(function() { 
$(".u_notify_succ").empty();
 }, 2000);
  })
  .fail((jqXHR, textStatus, errorThrown) => {
    console.error("Request failed:", textStatus, errorThrown);
    console.log("Response Text:", jqXHR.responseText);
  const jsonResponse = JSON.parse(jqXHR.responseText);
      if (jsonResponse.errors && jsonResponse.errors.length > 0) {
        jsonResponse.errors.forEach((error, index) => {
          console.log(`Error ${index + 1}:`);
          console.log("Detail:", error.detail);
              $(".u_notify_error").text(error.detail);
    setTimeout(function() { 
$(".u_notify_error").empty();
 }, 2000);
        });
      } 
  });

  });
  

  $("body").mouseover(function(e){
    console.log('body click  per')
    $('.dropdown_container').hide()
  });
  
  $('.search_link').mouseover(function(e){
    console.log('show')
    e.stopPropagation()
    $('.dropdown_container').show()
  })
  
  //search hide exept form box
  $('.dropdown_container,.search_link').mouseover(function(e){
    console.log('stop propagation per')
    e.stopPropagation();
  })
  let c_country_code = $('.u_country_popup_btn').val().trim()
  if(c_country_code == 'USD'){
    console.log('Your locallization country is US');
    US_Shipping()
    $('.after_detail').show()
  }
  else{
    Int_Shipping()
    $('.after_detail').hide()
    $('.u_int_customers').show()
    $('.u_usa_customers').hide()
    $('.u_int_msg').attr('style','display:block !important')
    $('.u_usa_msg').attr('style','display:none !important')
    console.log("localization International country")
  }
  function US_Shipping(){
    $.getJSON('/cart.js',function(cart){
      let total_price = parseInt(cart.total_price);
      console.log('total price',total_price);
      let threshold = '10000';
      console.log('threshold',threshold);
      let value_left = threshold - total_price;
      let value_left_money = Shopify.formatMoney(value_left);
      let bar_value = total_price/threshold;
      let bar_value_int = parseInt(total_price/threshold);
      console.log('bar value',bar_value)
      if(bar_value_int >= 1){
        $('.u_inner_bar').attr('style','width:100%');
        let unlocked_text = 'Free shipping on your order';
        $('.u_shipping_message').text(`${unlocked_text}`)
      }
      else{
        console.log('value left',value_left);
        let bar_width = bar_value*100;
        console.log('bar width',bar_width)
        $('.u_inner_bar').attr('style','width:'+bar_width+'%');
        let locked_text = 'Free shipping when you spend [value]';
        console.log('locked text',locked_text)
        locked_text = locked_text.replace("[value]",value_left_money)
        console.log('locked text',locked_text)
        
        let index = locked_text.indexOf('.')
        if(index){
          let f_text = locked_text.slice('0',index)
          let n_text = locked_text.replace('.00','')
          $('.u_shipping_message').text(`${n_text}`)
        }
        else{
          $('.u_shipping_message').text(`${locked_text}`)
        }
          // console.log('index',index)
          // let f_value =  value_left_money.slice('0',index)
          // $('.u_shipping_message').text(`${locked_text}`)
      }
    })
  }
  function Int_Shipping(){
    $.getJSON('/cart.js',function(cart){
      let total_price = parseInt(cart.total_price);
      console.log('total price',total_price);
      let threshold = '20000';
      console.log('threshold',threshold);
      let value_left = threshold - total_price;
      let value_left_money = Shopify.formatMoney(value_left);
      let bar_value = total_price/threshold;
      let bar_value_int = parseInt(total_price/threshold);
      console.log('bar value',bar_value)
      if(bar_value_int >= 1){
        $('.u_inner_bar').attr('style','width:100%');
        let unlocked_text = 'Free shipping on your order';
        $('.u_shipping_message').text(`${unlocked_text}`)
      }
      else{
        console.log('value left',value_left);
        let bar_width = bar_value*100;
        console.log('bar width',bar_width)
        $('.u_inner_bar').attr('style','width:'+bar_width+'%');
        let locked_text = 'Free shipping when you spend $200 USD';
        console.log('locked text',locked_text)
        locked_text = locked_text.replace("[value]",value_left_money)
        
        console.log('locked text',locked_text,value_left_money)
        let index = locked_text.indexOf('.')
        console.log('index',index)
        if(index){
          let f_text = locked_text.slice('0',index)
          let n_text = locked_text.replace('.00','')
          $('.u_shipping_message').text(`${n_text}`)
        }
        else{
          $('.u_shipping_message').text(`${locked_text}`)
        }
      }
    })
  }
});

$(document).ready(function() {
  // $('.clouserslider').flickity('resize');
  // $('.clouserslider').flickity({
  //   // options
  //   cellAlign: 'left',
  //   contain: true
  // });
});

// $('.main-carousel').flickity({
//   // options
//   cellAlign: 'left',
//   contain: true
// });
